import { createFileRoute } from '@tanstack/react-router'

import { ClaudeCodeSettingsPage } from '#features/integrations/claude-code/claude-code-settings-page'

export const Route = createFileRoute(
  '/_app/$workspace/settings/integrations/claude-code',
)({
  head: () => ({
    meta: [
      {
        title: 'Claude Code integration',
      },
    ],
  }),
  component: () => <ClaudeCodeSettingsPage />,
})
